// The four languages General ERP ships with.
//
// The company profile sets the instance default (§15: what the user sees is in
// the client's language); the switcher in the user menu is each person's own
// override, kept on their account and copied into the browser for the first
// paint (see accountPreferences.js).

export const LANGUAGES = [
  { code: 'es', label: 'ES', name: 'Español',  locale: 'es-ES' },
  { code: 'ca', label: 'CA', name: 'Català',   locale: 'ca-ES' },
  { code: 'en', label: 'EN', name: 'English',  locale: 'en-GB' },
  { code: 'fr', label: 'FR', name: 'Français', locale: 'fr-FR' },
]

export const SUPPORTED_CODES = LANGUAGES.map(language => language.code)

export const STORAGE_KEY = 'general.locale'

/** Two-letter code from a full locale ('ca-ES' -> 'ca'), falling back to Spanish. */
export function toCode(locale) {
  const code = String(locale ?? '').split('-')[0]
  return SUPPORTED_CODES.includes(code) ? code : 'es'
}
